<template>
  <div class="vdo-view box">
    <LectureVideo v-if="url" :url="url" />
  </div>
</template>
<script>
import LectureVideo from "./DisplayLectureByType/Video.vue";

export default {
  name: "LectureList",
  components: {
    LectureVideo
  },
  computed: {
    url() {
      return this.$store.getters.liveUrl;
    }
  }
};
</script>